import { render } from "./Master.vue?vue&type=template&id=208e4303"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__